import { ref } from 'vue';
import { Form as AForm } from 'ant-design-vue/es/components';
export default {
  name: 'TextEditor',
  props: {
    editMode: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    },
    error: {
      type: String,
      default: ''
    }
  },
  emits: ['update:value', 'blur', 'focus'],
  setup(props, context) {
    const formItemContext = AForm.useInjectFormItemContext();
    const isFocused = ref(false);
    const handleBLur = e => {
      isFocused.value = false;
      context.emit('blur', e);
      formItemContext.onFieldBlur();
    };
    const handleFocus = e => {
      context.emit('focus', e);
      isFocused.value = true;
    };
    const handleUpdateValue = val => {
      context.emit('update:value', val);
    };
    return {
      handleBLur,
      handleFocus,
      handleUpdateValue,
      isFocused
    };
  }
};